import { isIncludeSpecialCharacters, isOnlyNumbers } from 'ui/helpers/utils';

const OtpInput = ({ id, previousId, nextId, value, onValueChange, classNames }: any) => {
  // Handle keyup event
  const handleKeyUp = (e) => {
    //check if key is backspace or arrowleft
    if (e.keyCode === 8 || e.keyCode === 37) {
      const prev = document.getElementById(previousId) as HTMLInputElement;
      if (prev) {
        sessionStorage.setItem('fix-viewport', 'true');
        prev.select();
      } else {
        sessionStorage.removeItem('fix-viewport');
      }
      return;
    }

    //check if key is right arrow key
    if (e.keyCode === 39) {
      const next = document.getElementById(nextId) as HTMLInputElement;
      if (next) {
        sessionStorage.setItem('fix-viewport', 'true');
        next.select();
      } else {
        sessionStorage.removeItem('fix-viewport');
      }
      return;
    }
  };

  // Handle change input value
  const handleChange = (e) => {
    const inputValue = e.target.value.toString();

    // Make sure that OTP input is only 1 char
    if (inputValue.length > 1) {
      return;
    }

    // Check if input is not a number
    if (!isOnlyNumbers(inputValue)) {
      onValueChange(id, '');
      return;
    }

    // Check if value is special characters, then reset value
    if (isIncludeSpecialCharacters(inputValue)) {
      onValueChange(id, '');
      return;
    }

    // Change the value
    onValueChange(id, inputValue);

    // Move to the next box if there is an input value (not moved when deleted)
    if (inputValue) {
      const next = document.getElementById(nextId) as HTMLInputElement;
      if (next) {
        sessionStorage.setItem('fix-viewport', 'true');
        next.select();
      } else {
        sessionStorage.removeItem('fix-viewport');
      }
      return;
    }
  };

  const blockInvalidChar = (e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();

  return (
    <input
      id={id}
      className={`inline-block p-4 bg-reliableBlack3 text-reliableBlack text-center border-b border-reliableBlack70 ${classNames}`}
      name={id}
      type="number"
      pattern="[0-9]*"
      inputMode="numeric"
      value={value}
      maxLength={1}
      onChange={handleChange}
      onKeyUp={handleKeyUp}
      onKeyDown={blockInvalidChar}
      onFocus={() => {
        setTimeout(() => {
          sessionStorage.removeItem('fix-viewport');
        }, 100);
      }}
    />
  );
};

OtpInput.defaultProps = {
  classNames: '',
};

export default OtpInput;
